import React from 'react';
export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if (!href?.startsWith('#')) return;
    const targetId = href.substring(1);
    const element = document.getElementById(targetId);
    if (!element) return;
    const headerOffset = 20;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };
  return <section className="pt-8 sm:pt-12 pb-16 sm:pb-20 px-4 sm:px-6" data-id="element-127">
      <div className="max-w-6xl mx-auto rounded-2xl sm:rounded-3xl relative overflow-hidden shadow-xl" data-id="element-128">
        <div className="absolute inset-0 bg-cream-200" data-id="element-129" />
        <div className="relative z-10 text-center px-4 sm:px-8 md:px-16 py-12 sm:py-16" data-id="element-130">
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-bold leading-tight text-navy-800" data-id="element-131">
            <div data-id="element-132">
              Build Your <span className="text-gradient" data-id="element-133">Legacy</span>
            </div>
            <div className="text-navy-800" data-id="element-134">
              Through Strategic Wealth Creation
            </div>
          </h1>
          <p className="mt-6 sm:mt-8 max-w-2xl mx-auto text-sm sm:text-base md:text-lg text-navy-700" data-id="element-135">
            Join our exclusive community of entrepreneurs and investors who are
            creating generational wealth through proven systems and strategies.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8 sm:mt-12" data-id="element-136">
            <a href="https://link.builderspro.io/widget/form/Y62ZKJUTn6F3f3jyumwK" target="_blank" rel="noopener noreferrer" className="btn-legacy-gold inline-flex items-center justify-center" data-id="element-137">
              Start Your Journey
            </a>
            <a href="#strategy" onClick={handleNavClick} className="btn-white-gold inline-flex items-center justify-center" data-id="element-138">
              Learn More
            </a>
          </div>
        </div>
      </div>
      {/* What is Legacy Lab section */}
      <div className="max-w-4xl mx-auto mt-24 px-4" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <h2 className="text-3xl sm:text-4xl font-bold mb-8" data-id="element-141">
            Why Choose <span className="text-gradient" data-id="element-142">Legacy Lab</span>
          </h2>
          <p className="text-lg sm:text-xl text-navy-700 mb-8" data-id="element-143">
            We combine proven wealth-building strategies with cutting-edge
            approaches to help you create lasting financial freedom.
          </p>
          <div className="flex flex-col items-center max-w-3xl mx-auto" data-id="element-144">
            {/* Benefits in a more structured format */}
            <div className="w-full max-w-xl mx-auto bg-white border border-cream-300 rounded-xl p-6 mb-12 shadow-sm" data-id="element-145">
              <ul className="space-y-4 text-left" data-id="element-146">
                <li className="flex items-baseline" data-id="element-147">
                  <span className="text-gold-500 mr-3 text-lg" data-id="element-148">•</span>
                  <span className="text-lg text-navy-700" data-id="element-149">
                    Build personal and business capital
                  </span>
                </li>
                <li className="flex items-baseline" data-id="element-150">
                  <span className="text-gold-500 mr-3 text-lg" data-id="element-151">•</span>
                  <span className="text-lg text-navy-700" data-id="element-152">
                    Leverage cutting-edge strategies like liquidity pools, PDA
                    stacking, and private funding
                  </span>
                </li>
                <li className="flex items-baseline" data-id="element-153">
                  <span className="text-gold-500 mr-3 text-lg" data-id="element-154">•</span>
                  <span className="text-lg text-navy-700" data-id="element-155">
                    Establish a financial fortress for generations to come
                  </span>
                </li>
              </ul>
            </div>
            {/* Final statement with emphasis */}
            <div className="text-center" data-id="element-156">
              <p className="text-xl sm:text-2xl mb-4 text-navy-800" data-id="element-157">
                This isn't about "someday."
              </p>
              <p className="text-xl sm:text-2xl mb-8 text-navy-800" data-id="element-158">
                It's about <span className="font-semibold" data-id="element-159">right now</span> —
                with the right people and the right playbook.
              </p>
              <p className="text-2xl sm:text-3xl font-semibold text-gradient mt-6" data-id="element-160">
                Legacy Lab is where wealth architects come to work.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}